export default "/images/small-waves.svg?6676a508912ea5c889323a46bce8031a";